export const webposDe = {
  // General
  'webpos.title': 'Web-Kasse',
  'webpos.loading': 'Web-Kasse wird geladen...',
  'webpos.noConnection': 'Keine Verbindung zum Server — Verkauf nicht möglich. Verbindung wird wiederhergestellt...',
  'webpos.poweredBy': 'Powered by BISpicy POS',

  // Setup
  'webpos.setup.title': 'BISpicy Web-Kasse',
  'webpos.setup.subtitle': 'Richten Sie diese Kasse ein, um mit dem Verkauf zu beginnen.',
  'webpos.setup.deviceName': 'Kassenname',
  'webpos.setup.deviceNamePlaceholder': 'z.B. PC Büro, iPad Theke',
  'webpos.setup.register': 'Kasse registrieren',
  'webpos.setup.registering': 'Wird registriert...',
  'webpos.setup.alreadyRegistered': 'Dieses Gerät ist bereits registriert.',
  'webpos.setup.registerNotAllowed': 'Ein neues Gerät kann nur ein Administrator oder Manager (Recht Geräteverwaltung) einrichten. Bitte an diesem Gerät mit einem solchen Konto bei BIS ERP anmelden.',

  // License
  'webpos.license.required': 'Lizenz erforderlich',
  'webpos.license.instructions': 'Bitte weisen Sie dieser Web-Kasse im Kundencenter eine Lizenz zu.',
  'webpos.license.howTo': 'So geht\'s:',
  'webpos.license.step1': '1. Kundencenter öffnen',
  'webpos.license.step2': '2. "Meine Geräte" aufrufen',
  'webpos.license.step3': '3. Diese Web-Kasse finden',
  'webpos.license.step4': '4. "Lizenz zuweisen" klicken',
  'webpos.license.goToPortal': 'Zum Kundencenter',
  'webpos.license.reload': 'Seite neu laden (nach Lizenzzuweisung)',

  // Login
  'webpos.login.title': 'Mitarbeiter-PIN eingeben',
  'webpos.login.pinTooShort': 'PIN muss mindestens 4 Stellen haben',
  'webpos.login.invalidPin': 'Ungültige PIN',
  'webpos.login.withoutPin': 'Ohne PIN fortfahren',

  // Sales
  'webpos.sales.search': 'Suche / Barcode scannen...',
  'webpos.sales.allCategories': 'Alle',
  'webpos.sales.favorites': 'Nur Favoriten',
  'webpos.sales.parkSale': 'Verkauf parken',
  'webpos.sales.noProducts': 'Keine Produkte vorhanden',
  'webpos.sales.noResults': 'Keine Produkte gefunden',

  // Cart
  'webpos.cart.title': 'Warenkorb',
  'webpos.cart.empty': 'Warenkorb ist leer',
  'webpos.cart.clear': 'Leeren',
  'webpos.cart.subtotal': 'Zwischensumme',
  'webpos.cart.discount': 'Rabatt',
  'webpos.cart.total': 'Gesamt',
  'webpos.cart.vat': 'MwSt',
  'webpos.cart.pay': 'Bezahlen',
  'webpos.cart.items': 'Artikel',

  // Payment
  'webpos.payment.title': 'Bezahlen',
  'webpos.payment.toPay': 'Zu zahlen',
  'webpos.payment.cash': 'Barzahlung',
  'webpos.payment.card': 'Kartenzahlung',
  'webpos.payment.split': 'Teilzahlung (Bar + Karte)',
  'webpos.payment.promptpay': 'PromptPay QR',
  'webpos.payment.given': 'Gegeben',
  'webpos.payment.change': 'Rückgeld',
  'webpos.payment.exact': 'Passend',
  'webpos.payment.process': 'Kassieren',
  'webpos.payment.processing': 'Verkauf wird verarbeitet...',
  'webpos.payment.success': 'Verkauf abgeschlossen',
  'webpos.payment.nextCustomer': 'Nächster Kunde',
  'webpos.payment.back': 'Zurück',

  // Cash Session
  'webpos.cashSession.open': 'Kasseneröffnung',
  'webpos.cashSession.close': 'Kassenschluss (Z-Bon)',
  'webpos.cashSession.cashier': 'Kassierer',
  'webpos.cashSession.denomination': 'Stückelung (Anfangsbestand)',
  'webpos.cashSession.initialAmount': 'Anfangsbestand',
  'webpos.cashSession.openCash': 'Kasse öffnen',
  'webpos.cashSession.opening': 'Wird geöffnet...',
  'webpos.cashSession.countedAmount': 'Gezählter Kassenbestand',
  'webpos.cashSession.closeCash': 'Kasse schließen',
  'webpos.cashSession.closing': 'Wird geschlossen...',
  'webpos.cashSession.expected': 'SOLL',
  'webpos.cashSession.actual': 'IST (gezählt)',
  'webpos.cashSession.difference': 'Differenz',
  'webpos.cashSession.cashSales': 'Barverkäufe',
  'webpos.cashSession.deposits': 'Einlagen',
  'webpos.cashSession.withdrawals': 'Entnahmen',

  // Cash Movement
  'webpos.cashMovement.title': 'Bargeldbewegung',
  'webpos.cashMovement.deposit': 'Einlage',
  'webpos.cashMovement.withdrawal': 'Entnahme',
  'webpos.cashMovement.amount': 'Betrag',
  'webpos.cashMovement.category': 'Kategorie',
  'webpos.cashMovement.reason': 'Grund (optional)',
  'webpos.cashMovement.bookDeposit': 'Einlage buchen',
  'webpos.cashMovement.bookWithdrawal': 'Entnahme buchen',

  // Discounts
  'webpos.discount.title': 'Rabatt',
  'webpos.discount.presets': 'Vordefiniert',
  'webpos.discount.custom': 'Individuell',
  'webpos.discount.percent': 'Prozentualer Rabatt',
  'webpos.discount.fixed': 'Fester Betrag',
  'webpos.discount.apply': 'Rabatt anwenden',

  // Vouchers
  'webpos.voucher.title': 'Gutschein einlösen',
  'webpos.voucher.enterCode': 'Gutscheincode eingeben...',
  'webpos.voucher.remaining': 'Restwert',
  'webpos.voucher.redeemAmount': 'Einzulösender Betrag',
  'webpos.voucher.redeem': 'Gutschein einlösen',
  'webpos.voucher.redeemed': 'Gutschein eingelöst!',
  'webpos.voucher.notFound': 'Gutschein nicht gefunden',
  'webpos.voucher.expired': 'Gutschein ist abgelaufen',

  // Customer
  'webpos.customer.title': 'Kunde zuordnen',
  'webpos.customer.search': 'Name, E-Mail, Telefon oder Kundennummer...',
  'webpos.customer.none': 'Keine Kunden gefunden',
  'webpos.customer.remove': 'Entfernen',

  // Deposit Return
  'webpos.deposit.title': 'Leergut-Rücknahme',
  'webpos.deposit.payout': 'Auszahlung',
  'webpos.deposit.confirm': 'Leergut auszahlen',

  // History
  'webpos.history.title': 'Verkaufshistorie',
  'webpos.history.receipts': 'Belege',
  'webpos.history.searchReceipt': 'Bonnummer suchen...',
  'webpos.history.noSales': 'Keine Verkäufe gefunden',
  'webpos.history.cancelled': 'Storniert',
  'webpos.history.printReceipt': 'Bon drucken',
  'webpos.history.cancel': 'Stornieren',
  'webpos.history.cancelTitle': 'Verkauf stornieren',
  'webpos.history.cancelReason': 'Bitte geben Sie einen Stornierungsgrund an.',
  'webpos.history.cancelReasons.customerRequest': 'Kundenwunsch',
  'webpos.history.cancelReasons.wrongItem': 'Falscher Artikel',
  'webpos.history.cancelReasons.wrongPrice': 'Falscher Preis',
  'webpos.history.cancelReasons.wrongQuantity': 'Falsche Menge',
  'webpos.history.cancelReasons.duplicate': 'Doppelbuchung',
  'webpos.history.cancelReasons.other': 'Sonstiges',

  // Gastro / Tables
  'webpos.gastro.free': 'frei',
  'webpos.gastro.occupied': 'besetzt',
  'webpos.gastro.noTables': 'Keine Tische eingerichtet',
  'webpos.gastro.addTable': 'Tisch hinzufügen',
  'webpos.gastro.tableNumber': 'Tischnummer',
  'webpos.gastro.capacity': 'Kapazität',
  'webpos.gastro.createTable': 'Tisch anlegen',
  'webpos.gastro.order': 'Bestellung',
  'webpos.gastro.products': 'Produkte',
  'webpos.gastro.settle': 'Abrechnen',
  'webpos.gastro.sendToKitchen': 'An Küche',
  'webpos.gastro.sending': 'Wird gesendet...',
  'webpos.gastro.noItems': 'Noch keine Artikel bestellt',
  'webpos.gastro.statusNew': 'Neu',
  'webpos.gastro.statusSent': 'Küche',

  // Settings
  'webpos.settings.title': 'Einstellungen',
  'webpos.settings.deviceInfo': 'Geräte-Info',
  'webpos.settings.printer': 'Drucker',
  'webpos.settings.printMode': 'Druckmodus',
  'webpos.settings.printModeBisprint': 'BISPrint',
  'webpos.settings.printModeBisprintDesc': 'Cloud-Druck über BISPrint-Client',
  'webpos.settings.printModeBrowser': 'Browser-Druck',
  'webpos.settings.printModeBrowserDesc': 'HTML-Bon per window.print()',
  'webpos.settings.defaultPrinter': 'Standard-Drucker',
  'webpos.settings.savePrintSettings': 'Druckeinstellungen speichern',
  'webpos.settings.saved': 'Gespeichert',
  'webpos.settings.customerDisplay': 'Kundendisplay',
  'webpos.settings.customerDisplayDesc': 'Öffnen Sie diese URL auf einem zweiten Bildschirm oder Tablet, um den Warenkorb live für den Kunden anzuzeigen.',
  'webpos.settings.shortcuts': 'Tastenkürzel',

  // Menu
  'webpos.menu.openCash': 'Kasse öffnen (F8)',
  'webpos.menu.closeCash': 'Kasse schließen (F8)',
  'webpos.menu.cashMovement': 'Bargeldbewegung',
  'webpos.menu.depositReturn': 'Leergut-Rücknahme',
  'webpos.menu.history': 'Verkaufshistorie',
  'webpos.menu.settings': 'Einstellungen',
  'webpos.menu.shortcuts': 'Tastenkürzel:',

  // Customer Display
  'webpos.display.welcome': 'Herzlich Willkommen!',
  'webpos.display.thankYou': 'Vielen Dank für Ihren Einkauf!',
  'webpos.display.pleasePayTitle': 'Bitte zahlen',
  'webpos.display.total': 'Gesamt',

  // Common
  'webpos.common.cancel': 'Abbrechen',
  'webpos.common.close': 'Schließen',
  'webpos.common.save': 'Speichern',
  'webpos.common.delete': 'Löschen',
  'webpos.common.or': 'oder',
  'webpos.common.previous': 'Zurück',
  'webpos.common.next': 'Weiter',
  'webpos.common.saving': 'Speichert...',
  'webpos.common.loading': 'Lade Kunden...',
  'webpos.common.reload': 'Neu laden',
  'webpos.common.edit': 'Bearbeiten',

  // Customers (WebPOS Kunden CRUD)
  'webpos.customers.title': 'Kunden',
  'webpos.customers.subtitle': 'Kundenstammdaten verwalten — synchron mit Kassen-App & Kundencenter',
  'webpos.customers.add': 'Kunde anlegen',
  'webpos.customers.searchPlaceholder': 'Suche nach Name, Firma, Kundennummer, E-Mail oder Telefon',
  'webpos.customers.statTotal': 'Gesamt',
  'webpos.customers.statActive': 'Aktiv',
  'webpos.customers.statInactive': 'Inaktiv',
  'webpos.customers.colNumber': 'Kd.-Nr.',
  'webpos.customers.colName': 'Name',
  'webpos.customers.colContact': 'Kontakt',
  'webpos.customers.colAddress': 'Adresse',
  'webpos.customers.colDiscount': 'Rabatt',
  'webpos.customers.colStatus': 'Status',
  'webpos.customers.active': 'Aktiv',
  'webpos.customers.inactive': 'Inaktiv',
  'webpos.customers.unnamed': '(Ohne Namen)',
  'webpos.customers.pageInfo': 'Seite {{page}} von {{pages}} · {{total}} Kunden',
  'webpos.customers.emptyState': 'Noch keine Kunden vorhanden.',
  'webpos.customers.noResultsSearch': 'Keine Kunden entsprechen deiner Suche.',
  'webpos.customers.loadFailed': 'Laden fehlgeschlagen',
  'webpos.customers.saveFailed': 'Speichern fehlgeschlagen',
  'webpos.customers.deleteFailed': 'Löschen fehlgeschlagen',
  'webpos.customers.created': 'Kunde angelegt',
  'webpos.customers.updated': 'Kunde gespeichert',
  'webpos.customers.deleted': 'Kunde deaktiviert',
  'webpos.customers.createTitle': 'Neuer Kunde',
  'webpos.customers.editTitle': 'Kunde bearbeiten',
  'webpos.customers.createBtn': 'Anlegen',
  'webpos.customers.deleteConfirmTitle': 'Kunde deaktivieren?',
  'webpos.customers.deleteConfirmMessage': 'Der Kunde wird auf „inaktiv" gesetzt. Bereits erstellte Rechnungen und Belege bleiben erhalten.',
  'webpos.customers.secBasics': 'Stammdaten',
  'webpos.customers.secContact': 'Kontakt',
  'webpos.customers.secAddress': 'Rechnungsadresse',
  'webpos.customers.secConditions': 'Konditionen',
  'webpos.customers.secNotes': 'Notizen & Status',
  'webpos.customers.fCustomerNumber': 'Kundennummer',
  'webpos.customers.fCustomerNumberHint': 'Leer = automatisch',
  'webpos.customers.fCompanyName': 'Firma',
  'webpos.customers.fFirstName': 'Vorname',
  'webpos.customers.fLastName': 'Nachname',
  'webpos.customers.fEmail': 'E-Mail',
  'webpos.customers.fPhone': 'Telefon',
  'webpos.customers.fMobile': 'Mobil',
  'webpos.customers.fVatId': 'USt-IdNr.',
  'webpos.customers.fStreet': 'Straße',
  'webpos.customers.fHouseNumber': 'Nr.',
  'webpos.customers.fPostalCode': 'PLZ',
  'webpos.customers.fCity': 'Ort',
  'webpos.customers.fCountry': 'Land',
  'webpos.customers.fDiscount': 'Rabatt (%)',
  'webpos.customers.fPaymentTerms': 'Zahlungsziel (Tage)',
  'webpos.customers.fNotes': 'Interne Notizen',
  'webpos.customers.fActive': 'Kunde ist aktiv',

  // Als App installieren / Vollbild
  'webpos.install.title': 'Kasse im Vollbild öffnen',
  'webpos.install.subtitle': 'Ohne Browser-Leiste – als Symbol auf dem Startbildschirm, wie eine App.',
  'webpos.install.benefit1': 'Vollbild ohne Adress- und Menüleiste',
  'webpos.install.benefit2': 'Eigenes Kassen-Symbol auf dem Startbildschirm',
  'webpos.install.benefit3': 'Öffnet direkt im Vollbild',
  'webpos.install.button': 'Zum Startbildschirm hinzufügen',
  'webpos.install.later': 'Später',
  'webpos.install.dontShowAgain': 'Nicht mehr anzeigen',
  'webpos.install.iosTitle': 'In 2 Schritten zum Vollbild',
  'webpos.install.iosStep1': 'Unten auf das Teilen-Symbol tippen',
  'webpos.install.iosStep2': '„Zum Home-Bildschirm" wählen',
  'webpos.install.iosHint': 'Danach die Kasse über das neue Symbol öffnen – sie läuft dann im Vollbild ohne Browser-Leiste.',
  'webpos.install.menuLabel': 'Im Vollbild öffnen',
  'webpos.install.iosOtherTitle': 'Für Vollbild bitte Safari nutzen',
  'webpos.install.iosOtherHint': 'In diesem Browser lässt sich auf iPhone/iPad kein Vollbild einrichten. Bitte pos.bispicy.com in Safari öffnen und dort „Teilen → Zum Home-Bildschirm" wählen.',
  'webpos.install.androidTitle': 'In 2 Schritten zum Vollbild',
  'webpos.install.androidStep1': 'Browser-Menü (⋮) öffnen',
  'webpos.install.androidStep2': '„Zum Startbildschirm hinzufügen" wählen',
  'webpos.install.androidHint': 'Danach die Kasse über das neue Symbol öffnen – im Vollbild ohne Browser-Leiste.',
  'webpos.install.fullscreenNow': 'Stattdessen jetzt im Vollbild öffnen',

  // Navigations-Drawer (☰) — Labels 1:1 aus der nativen Kassenapp
  'webpos.nav.dashboard': 'Übersicht',
  'webpos.nav.sales': 'Verkäufe',
  'webpos.nav.repairOrders': 'Aufträge',
  'webpos.nav.tablePlan': 'Tischplan',
  'webpos.nav.salesHistory': 'Verkaufshistorie',
  'webpos.nav.products': 'Artikel',
  'webpos.nav.customers': 'Kunden',
  'webpos.nav.appointments': 'Termine',
  'webpos.nav.reports': 'Berichte',
  'webpos.nav.settings': 'Einstellungen',
  'webpos.drawer.logout': 'Abmelden',
  'webpos.drawer.language': 'Sprache',
  'webpos.drawer.fullscreen': 'Im Vollbild öffnen',

  // Dashboard / Übersicht
  'webpos.dashboard.title': 'Übersicht',
  'webpos.dashboard.todayRevenue': 'Umsatz heute',
  'webpos.dashboard.todaySales': 'Bons heute',
  'webpos.dashboard.products': 'Artikel',
  'webpos.dashboard.customers': 'Kunden',
  'webpos.dashboard.lowStock': 'Ausverkauft',

  // V-0642: Kassenmeldung (§ 146a Abs. 4 AO) auf der TSE-Seite — der Betrieb meldet selbst.
  'webpos.tse.kassenmeldung_titel': 'Kassenmeldung',
  'webpos.tse.kassenmeldung_text': 'Die Mitteilung nach § 146a Abs. 4 AO übermitteln Sie selbst über Mein ELSTER oder über Ihr Steuerbüro. Die nötigen Angaben (u. a. Seriennummer der TSE, Modell und Kürzel der Kasse) finden Sie im Kundencenter unter „Verfahrensdokumentation“. Bei Fragen hilft Ihnen der Support.',

  // V-0607: Leergut-Rücknahme / Pfandrückgabe
  'webpos.pfand.title': 'Leergut-Rücknahme',
  'webpos.pfand.payout': 'Auszahlung',
  'webpos.pfand.pieces': '{{count}} Stück',
  'webpos.pfand.confirm': 'Leergut auszahlen',
  'webpos.pfand.empty': 'Für diesen Betrieb sind keine Pfandarten hinterlegt.',
  'webpos.pfand.addFailed': 'Die Pfandrückgabe konnte nicht hinzugefügt werden.',
  'webpos.pfand.toPay': 'Auszuzahlen',
  'webpos.pfand.payoutCash': 'Pfand bar auszahlen',
  'webpos.pfand.payoutHint': 'Der Bon ist negativ: Das Geld wird bar aus der Kasse ausgezahlt.',
  'webpos.pfand.payoutFailed': 'Die Auszahlung ist fehlgeschlagen.',

  // V-0582: Bondruck über BISPrint
  'webpos.print.noReceiptPrinter': 'Kein Bondrucker erreichbar — der Bon wurde nicht gedruckt.',
  'webpos.print.noKitchenPrinter': 'Der zugeordnete Küchendrucker ist nicht erreichbar — der Küchenbon wurde nicht gedruckt. Die Positionen sind an die Küche gesendet.',
  'webpos.print.receiptFailed': 'Der Bon konnte nicht an den Drucker übergeben werden.',
  'webpos.print.kitchenFailed': 'Der Küchenbon konnte nicht an den Drucker übergeben werden. Die Positionen sind an die Küche gesendet.',
  'webpos.print.sent': 'Bon an den Drucker gesendet.',
  'webpos.print.settings.saveFailed': 'Die Druckeinstellung konnte nicht gespeichert werden.',
  'webpos.print.settings.receiptPrinterHint': 'Ohne Auswahl druckt der Bon auf dem in BIS ERP zugeordneten Bondrucker, sonst auf dem Standarddrucker des BISPrint-Arbeitsplatzes.',
  'webpos.print.settings.autoPrint': 'Bon nach dem Verkauf automatisch drucken',
  'webpos.print.settings.autoPrintHint': 'Der Bon wird nach jedem Verkauf über BISPrint ausgegeben. Der Druck über den Verkaufsverlauf funktioniert unabhängig davon.',
  'webpos.print.settings.autoPrintOff': 'Der automatische Bondruck ist für diese Kasse bisher aus. Schalten Sie ihn ein und speichern Sie, wenn jeder Verkauf automatisch gedruckt werden soll.',
  'webpos.print.settings.kitchenPrinter': 'Küchendrucker',
  'webpos.print.settings.autoPrintNeedsBisprint': 'Wirksam nur im Druckmodus „BISPrint Cloud“. Bei Browser-Druck (auch wenn nie gewählt) wird kein Bon automatisch gedruckt.',
  'webpos.print.settings.kitchenPrinterHint': 'Der Küchenbon wird bei „An Küche“ nur gedruckt, wenn hier oder in BIS ERP (Einstellungen → Druck, Belegart „Küchenbon“) ein Drucker zugeordnet ist.',
  'webpos.print.settings.kitchenPrinterDefault': 'Keiner (außer zentral in BIS ERP zugeordnet)',
  'webpos.print.settings.offline': 'offline',
};

